// extracted by mini-css-extract-plugin
module.exports = {"ViewToggle":"viewToggle_ViewToggle__GtXW8","toggleBtn":"viewToggle_toggleBtn__pioo9","active":"viewToggle_active__SEtdV"};